import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compose Tailwind class names safely.
 *  cn('px-4 py-2', isActive && 'bg-brand-500', errors && 'border-red-500')
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
